import {
    setInitialRequestState as setInitialVotingPageRequestState,
    setPollData as setVotingPagePollData,
    getOutlookMeetingPollAndMatchingRecipients,
    setGetPollSignedUrl,
    trySetVotingAsFromSignedInUserOrAddresses,
    trySetVotingAsFromStoredVotingAs,
    initFreeBusyCache,
    setDisplayTimeZone,
    showUnsubscribeDialog,
} from 'findtime-voting-page';
import {
    getOutlookMeetingPolls,
    setInitialRequestState as setInitialDashboardRequestState,
    setPollData as setDashboardPollData,
    getOutlookMeetingPollSettings,
    setSettingsRequestState,
    setSettingsData,
    OutlookMeetingPollSettings,
} from 'findtime-dashboard';
import {
    OutlookMeetingPoll,
    OutlookMeetingPollAndMatchingRecipientsResponse,
    RequestState,
} from 'findtime-shared';
import { isAnonymousUser } from 'owa-config/lib/anonymousUtils';
import getUserWorkingHoursTzId from 'owa-session-store/lib/selectors/getUserWorkingHoursTzId';
import { getOSTimeZoneId } from 'owa-datetime-store';
import { setLocale } from 'owa-localize';
import { getSupportedFallbackForLocale } from 'owa-shared-bootstrap/lib/getSupportedFallbackForLocale';

export function runAfterVotingPageBootstrap(getRequestUrl: string, unsubscribe: boolean) {
    setGetPollSignedUrl(getRequestUrl);
    setInitialVotingPageRequestState(RequestState.Pending);
    getOutlookMeetingPollAndMatchingRecipients().then(
        (response: OutlookMeetingPollAndMatchingRecipientsResponse) => {
            if (response?.poll) {
                if (isAnonymousUser()) {
                    setLocale(getSupportedFallbackForLocale(window.navigator.language).locale);
                }
                setVotingPagePollData(response.poll);
                trySetVotingAsFromSignedInUserOrAddresses(response?.matchingRecipients);
                trySetVotingAsFromStoredVotingAs();
                setDisplayTimeZone(
                    isAnonymousUser() ? getOSTimeZoneId() : getUserWorkingHoursTzId()
                );
                initFreeBusyCache();
                if (unsubscribe) {
                    // Mutator has additional business logic.
                    showUnsubscribeDialog();
                }
                if (response?.reasonCode == 'needs_auth') {
                    setInitialVotingPageRequestState(RequestState.NeedsAuthentication);
                } else {
                    setInitialVotingPageRequestState(RequestState.Complete);
                }
            } else {
                setInitialVotingPageRequestState(RequestState.Error);
            }
        }
    );
}

export function runAfterDashboardBootstrap() {
    setInitialDashboardRequestState(RequestState.Pending);
    getOutlookMeetingPolls().then((polls: OutlookMeetingPoll[]) => {
        if (polls) {
            setDashboardPollData(polls);
            setInitialDashboardRequestState(RequestState.Complete);
        } else {
            setInitialDashboardRequestState(RequestState.Error);
        }
    });
    setSettingsRequestState(RequestState.Pending);
    getOutlookMeetingPollSettings().then((settings: OutlookMeetingPollSettings) => {
        if (settings) {
            setSettingsData(settings);
            setSettingsRequestState(RequestState.Complete);
        } else {
            setSettingsRequestState(RequestState.Error);
        }
    });
}
